export default "/images/truck.svg?85a1997d70ae01fe8911b52574dd9362";